import React from 'react';
import CustomerForm from '../components/CustomerForm';
import ReportAdLayout from '../components/ReportAdLayout';

export default function InputPage() {
  const [loading,  setLoading]  = React.useState(false);
  const [apiError, setApiError] = React.useState('');

  async function handleFormSubmit(payload) {
    setLoading(true);
    setApiError('');
    try {
      const res = await fetch('/api/reports', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(payload),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.message || `서버 오류 (${res.status})`);
      }
      const { reportId, readToken } = await res.json();
      // Token is carried in the URL fragment — never sent to the server
      window.location.href = `/r/${reportId}#token=${readToken}`;
    } catch (err) {
      setApiError(err.message || '리포트 생성 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh' }}>
      <header className="lb-header">
        <div className="lb-header-inner">
          <a className="lb-logo" href="/">☕ 라떼비버</a>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <span style={{ color: 'var(--color-text-muted)', fontSize: '14px', fontWeight: 600 }}>
              은퇴 연금 리포트
            </span>
            <a
              className="lb-btn lb-btn-outline"
              href="https://comm.beaver-pension.com/?source=report&utm_source=report&utm_medium=cta"
              style={{ minHeight: '36px', padding: '0 14px', fontSize: '14px' }}
            >
              연금 질문하기
            </a>
          </div>
        </div>
      </header>

      <ReportAdLayout>
        <div className="lb-section-sm">
          <div className="lb-container" style={{ maxWidth: '680px' }}>
            <div className="lb-card lb-card-padded">
              <h2 className="lb-title-md" style={{ marginBottom: '6px' }}>연금 정보 입력</h2>
              <p className="lb-text-muted lb-text-sm" style={{ marginBottom: '28px' }}>
                아래 정보를 입력하면 맞춤형 은퇴 플래닝 리포트를 생성해 드립니다.
              </p>

              {apiError && (
                <div className="lb-alert lb-alert-error" style={{ marginBottom: '20px' }}>
                  {apiError}
                </div>
              )}

              <CustomerForm onSubmit={handleFormSubmit} loading={loading} />
            </div>

            <p className="lb-text-muted lb-text-sm" style={{ textAlign: 'center', marginTop: '16px' }}>
              입력하신 정보는 리포트 생성 목적으로만 사용됩니다.
              본 리포트는 참고용이며, 실제 투자 결정 시 전문가와 상담하시기 바랍니다.
            </p>
          </div>
        </div>
      </ReportAdLayout>
    </div>
  );
}
